<template>
  <div v-if="['disable', 'alert'].includes(type) && moduleName">
    <v-tooltip max-width="25vw" :bottom="!top" :top="top" :disabled="type !== 'disable'">
      <template #activator="{ on, attrs }">
        <div
          :class="[{ PackageAccessDisabled: type === 'disable' }, childClass]"
          v-bind="attrs"
          v-on="on"
          class="d-flex justify-center align-center"
          @click.capture="handleClickEvent"
        >
          <slot></slot>
        </div>
      </template>
      <span>{{ message }} </span>
    </v-tooltip>
  </div>
  <div v-else-if="type === 'hide' && moduleName"></div>
  <div v-else>
    <slot></slot>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "PackageAccess",
  props: {
    childClass: {
      type: String,
      default: "",
    },
    moduleName: {
      type: [String, Object],
    },
    top: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    moduleAccess() {
      return this.alwaysObject(this.$store.state.window?.packagemoduleaccess)[this.moduleName];
    },
    access() {
      return this.boolean(this.moduleAccess?.access ?? true);
    },
    type() {
      const type = this.moduleAccess?.errorType ?? "show";
      return ["alert", "disable", "hide", "show"].includes(type) ? type : "disable";
    },
    message() {
      return this.moduleAccess?.actionMsg ?? "";
    },
  },
  methods: {
    handleClickEvent($event) {
      if (this.access) {
        if ($event.type === "type") {
          $event.srcElement.dispatchEvent(new CustomEvent("click", { bubbles: true }));
        }
      } else {
        $event.stopPropagation();
        $event.preventDefault();
        if (this.type === "alert") {
          this.confirmDialog("Invalid Access", this.message);
        }
      }
    },
  },
  mounted() {
    if (this.type === "hide") {
      this.$el.setAttribute("class", "");
    }
  },
});
</script>

<style lang="scss">
.PackageAccessDisabled {
  display: flex;
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

.PackageAccessDisabled > * {
  pointer-events: none !important;
}
</style>
